import { AnyAction, combineReducers } from 'redux';
import { configureStore, getDefaultMiddleware, ThunkDispatch } from '@reduxjs/toolkit';
import { history } from '../appHistory';
import createSagaMiddleware from 'redux-saga';
import sagas from './sagas';
import { paymentProfileReducer } from 'modules/PaymentProfile';
import { notification } from 'stores/reducers/notification';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import pagetrack from './middlewares/pagetrack';
import { billsReducer } from 'modules/MyBills';
import { cancellationReducer } from 'modules/Cancellation';
import { reducers as userInfoReducers } from 'stores/userInfo';

export const rootReducer = combineReducers({
    paymentProfile: paymentProfileReducer,
    notification,
    bills: billsReducer,
    userInfo: userInfoReducers,
    cancellation: cancellationReducer,
    router: connectRouter(history),
});

export type RootState = ReturnType<typeof rootReducer>;

const sagaMiddleware = createSagaMiddleware();
const store = configureStore({
    reducer: rootReducer,
    middleware: [...getDefaultMiddleware(), sagaMiddleware, pagetrack, routerMiddleware(history)],
    devTools: process.env.NODE_ENV === 'development',
});

sagaMiddleware.run(sagas);

export type AppDispatch = typeof store.dispatch;
export type AppThunkDispatch = ThunkDispatch<RootState, object, AnyAction>;

export default store;
